import { cn } from '@app/libs/utils';

interface PageTitleProps {
  title: string;
  description?: string;
  className?: string;
  children?: React.ReactNode;
}

export const PageTitle: React.FC<PageTitleProps> = ({
  title,
  description,
  className,
  children,
}) => {
  return (
    <header className={cn('flex gap-2 items-center justify-between w-full flex-wrap', className)}>
      <div className="flex flex-col justify-center w-full md:w-auto grow">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {description && <p className="text-xs text-gray-500">{description}</p>}
      </div>
      <div className="flex items-center gap-2 justify-between w-full sm:w-auto grow md:grow-0">
        {children}
      </div>
    </header>
  );
};
